import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Text, VStack } from '@chakra-ui/react';
import Loading from '../../../Loading';
import requestTimeout from '../../../Utils/Functions/requestTimeout';
import { AccountContext } from 'components/AccountContext';
import { api } from 'api/api';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

function AguardandoPagamentoPet() {
  return (
    <VStack minH="100vh" justify="center" align="center" px={6} spacing={6} bg="white">
      <Text fontSize="4xl">🐾</Text>
      <Text fontWeight="bold" fontSize="18" color="#585858" textAlign="center">
        Aguardando confirmação do pagamento
      </Text>
      <Text fontSize="14" color="#888" textAlign="center">
        Quando o Pix for confirmado, você receberá um SMS com instruções para adicionar seu pet no app.
      </Text>
      <Button
        colorScheme="teal"
        borderRadius="full"
        w="80%"
        onClick={() => (window.location.href = '/')}
      >
        Ir para o início
      </Button>
    </VStack>
  );
}

function ProcessaPetPago() {
  const { state } = useLocation();
  const [loading, setLoading] = useState(true);
  const [pixAguardando, setPixAguardando] = useState(false);
  const navigate = useNavigate();
  const { user } = useContext(AccountContext);
  const timeOutInSeconds = process.env.REACT_APP_REQUEST_TIMEOUT_IN_SECONDS;

  useEffect(() => {
    if (state?.forma_pgto === 'pix') {
      setPixAguardando(true);
      setLoading(false);
      return;
    }
    gravarPagamento(state);
  }, []);

  function handleError() {
    setLoading(false);
    navigate('/alerts/erro/adicionar_pet');
  }

  function gravarPagamento(vals) {
    const paciente_contrato_id =
      vals.paciente_contrato_id ?? vals.item?.paciente_contrato_id ?? user.id_contrato;

    const installmentsData = [
      {
        paciente_contrato_id,
        valor: vals.valor ?? vals.item?.valor_extra_dep,
        taxa_adesao: true,
        id_trasacao_gatway: vals.transaction_id,
        classe: 'adesao adicional',
        forma_pgto: vals.forma_pgto,
      },
    ];

    api(`${ENDPOINT}/installments`, {
      signal: requestTimeout(timeOutInSeconds).signal,
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(installmentsData),
    })
      .catch(() => handleError())
      .then((res) => {
        if (!res || !res.ok || res.status >= 400) {
          handleError();
          return;
        }
        return res.json();
      })
      .then((data) => {
        if (!data) return;
        if (data[0]?.success) {
          navigate('/perfil/dependentes/cadastro-pet/', {
            state: {
              navigate_to: '/perfil/assinaturas',
              id_cliente_deovita: user.id_cliente_deovita,
              id_contrato: user.id_contrato,
              pago_pet: true,
            },
          });
        } else {
          handleError();
        }
      });
  }

  if (loading) return <Loading />;
  if (pixAguardando) return <AguardandoPagamentoPet />;
  return null;
}

export default ProcessaPetPago;
